import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT


//获取交流协作数据
export const getExchangeListData = (params) => {
  return axios.post(root+'/oa/exchange/list', qs.stringify(params))
}

//获取交流协作明细
export const getDetail = (params) => {
  return axios.get(root+'/oa/exchange/detail', {params:params})
}
//删除行
export const deleteData = (params) => {
  return axios.post(root+'/oa/exchange/remove',  qs.stringify(params))
}
//新增反馈内容
export const saveFeedBackData=(params)=>{
  return axios.post(root+'/oa/feedback/save', qs.stringify(params))
}

//删除反馈内容
export const DeleteFeedBackInfo = (params) => {
  return axios.post(root+'/oa/feedback/remove',  qs.stringify(params))
}
//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root+'/oa/exchange/update', qs.stringify(params))
  } else {//添加
    return axios.post(root+'/oa/exchange/save', qs.stringify(params))
  }
}


//更新交流协作的数据
export const updateData = (params) => {
    return axios.post(root+'/oa/exchange/update', qs.stringify(params))

}



// WEBPACK FOOTER //
// ./src/api/oa/exchange.js